module.exports = __webpack_public_path__ + "static/media/left-arrow-green.69355981.svg";